const { CONTRACT_TYPE, DEBIT_MOVEMENTS, CREDIT_MOVEMENTS, ALL_MOVEMENTS } = require('constants/expensesByCategories/filters');

const getFiltersRelatedToContractType = immFilters => {
    let selectedContractType = immFilters ? immFilters.getIn([CONTRACT_TYPE,'selected']) : ALL_MOVEMENTS,
        isCreditFilterSelected = true,
        isDebitFilterSelected = true;

    switch (selectedContractType) {
        case DEBIT_MOVEMENTS:
            return {
                isCreditFilterSelected: false,
                isDebitFilterSelected
            }
        case CREDIT_MOVEMENTS:
            return {
                isCreditFilterSelected,
                isDebitFilterSelected: false
            }
        default:
            return {
                isCreditFilterSelected,
                isDebitFilterSelected
            }
    }
}

export default getFiltersRelatedToContractType;